import React from "react";
import { useSelector } from "react-redux";
import { Grid } from "@material-ui/core";

const style = {
  item: {
    marginLeft: 60,
  },
  cursor: {
    cursor: "pointer",
  },
};

export const ContadoresAfiliado = (props) => {
  const { contadores } = useSelector((state) => state.agenda);

  return (
    <Grid container justify="center">
      <Grid item xs={2} style={style.item}>
        <h3
          onClick={() => {
            props.traerPorTipo(1);
            props.setDisplayListaCtaCte(false);
          }}
          style={style.cursor}
        >
          Turnos Tomados: {contadores?.tomados}
        </h3>
      </Grid>
      <Grid item xs={2} style={style.item}>
        <h3
          onClick={() => {
            props.traerPorTipo(2);
            props.setDisplayListaCtaCte(false);
          }}
          style={style.cursor}
        >
          Asistidos: {contadores?.asistidos}
        </h3>
      </Grid>
      <Grid item xs={2} style={style.item}>
        <h3
          onClick={() => {
            props.traerPorTipo(3);
            props.setDisplayListaCtaCte(false);
          }}
          style={style.cursor}
        >
          Cancelados: {contadores?.cancelados}
        </h3>
      </Grid>
      <Grid item xs={2} style={style.item}>
        <h3
          onClick={() => {
            props.traerPorTipo(4);
            props.setDisplayListaCtaCte(false);
          }}
          style={style.cursor}
        >
          No Concurridos: {contadores?.noConcurridos}
        </h3>
      </Grid>
    </Grid>
  );
};
